import { Box, Text } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import PaymentFailedIcon from '../img/paymentFailed.svg';

import { color } from 'theme/selectors';
import { HTMLAttributes } from 'react';

const flexBlock = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubscriptionCardHeader = styled.div<{ $isExpired?: boolean } & HTMLAttributes<HTMLDivElement>>`
  ${flexBlock};
  margin-bottom: 24px;

  ${({ $isExpired }) =>
    $isExpired &&
    css`
      img {
        opacity: 0.5;
      }
    `}
`;

export const Name = styled.div`
  ${flexBlock};
  gap: 8px;
`;

export const NotWrapBox = styled.div`
  white-space: nowrap;
`;

export const TextBox = styled.div`
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 24px;
  background: ${color('surface-main')};
`;

export const ExpandButton = styled.button<{ $isTabExpanded?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: all 0.3s ease;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  transform: rotate(180deg);

  svg {
    position: relative;
    top: 2px;
  }

  ${({ $isTabExpanded }) =>
    $isTabExpanded &&
    css`
      transform: rotate(0deg);
    `}
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 0;

  svg {
    margin-right: 5px;
  }
`;

export const PriceRow = styled.div`
  ${flexBlock};
`;

export const DateInfo = styled.div<{ 'data-locator'?: string; children?: React.ReactNode }>`
  margin-top: 20px;
  ${flexBlock};
`;

export const GeneralInfo = styled.div<{ $mb?: number; $mt?: number } & HTMLAttributes<HTMLDivElement>>`
  margin-bottom: ${({ $mb = 24 }) => $mb}px;
  margin-top: ${({ $mt = 0 }) => $mt}px;
`;

export const CancelButton = styled.button`
  margin-top: 24px;
  margin-bottom: 12px;
  cursor: pointer;
`;

export const FailedContainer = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background: ${color('surface-secondary')};
  border-radius: 12px;
`;

export const FailedIcon = styled(PaymentFailedIcon)`
  display: block;
  margin: 0 auto 7px;
`;

export const ListContainer = styled(Box)<{ $isCardRow?: boolean }>`
  ${({ $isCardRow }) =>
    $isCardRow &&
    css`
      display: flex;

      p {
        flex: 1;
        margin: 0;
      }

      ul {
        flex: 1;
      }
    `}

  ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop}px;`};
`;

export const List = styled.ul<{ isCardRow?: boolean; children?: React.ReactNode }>`
  color: ${({ isCardRow }) => (isCardRow ? color('text-main') : color('text-secondary-subdued'))};
  list-style: disc;
  margin: 0;
  padding-left: 20px;
`;

export const OneTimeDisclaimer = styled(Text)`
  margin-top: 12px;
`;

export const Disclaimer = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const SubscriptionDisclaimer = styled(Text)`
  margin-left: 6px;
  flex: 1;
  font-size: 14px;
`;
